var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex flex-col resource-card-wrapper bg-white mb-5 transition delay-75 duration-200",
      class: [_vm.optionalClasses, _vm.cardClass],
    },
    [
      _c(
        "div",
        {
          staticClass: "flex w-full flex-wrap bg-white rounded-2xl pb-4",
          class: _vm.bgClasses,
        },
        [
          _vm._t("default"),
          _vm.$scopedSlots.footer
            ? _c(
                "div",
                {
                  staticClass:
                    "flex w-full justify-between items-center rounded-b-2xl bg-white",
                  class: _vm.actionBarStyles,
                },
                [_vm._t("footer")],
                2
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }